import React from 'react';

export class AppErrorBoundary extends React.Component {
  state = {hasError:false};

  static getDerivedStateFromError() {
    return {hasError:true};
  }

  componentDidCatch(error) {
    console.error('Application rendering error:', error);
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    if (this.props.fallback !== undefined) return this.props.fallback;
    return <main data-testid="app-error-fallback" role="alert" className="min-h-screen bg-slate-50 px-6 py-16 text-center">
      <p data-testid="app-error-brand" className="text-green-700 font-black text-3xl mb-8">3DLoc</p>
      <h1 data-testid="app-error-heading" className="text-2xl sm:text-3xl font-bold text-slate-800 mb-4">L’affichage a rencontré un problème</h1>
      <p data-testid="app-error-description" className="text-slate-600 mb-8">La page n’a pas pu s’afficher correctement. Vous pouvez réessayer ou revenir à l’accueil.</p>
      <div className="flex flex-wrap justify-center gap-4">
        <button data-testid="app-error-retry" onClick={() => this.setState({hasError:false})} className="px-6 py-3 bg-green-600 hover:bg-green-700 transition-colors text-white rounded-lg">Réessayer</button>
        <a data-testid="app-error-home" href="/" className="px-6 py-3 border border-green-600 text-green-700 rounded-lg hover:bg-green-50 transition-colors">Revenir à l’accueil</a>
      </div>
    </main>;
  }
}